import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '../../../../../../utils/formatting';
import s from './MinimumOffer.scss';

interface Props {
  value: number;
}

const MinimumOffer: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <div className={s['label']}>{t('sidebar.exclusives.minimumOffer')}</div>
      <div className={s['value']}>{formatDollars(value)}</div>
    </div>
  );
};

MinimumOffer.displayName = 'MinimumOffer';

export default MinimumOffer;
